export const SET_ACTIVE_PAGE          = 'SET_ACTIVE_PAGE';
export const SET_HAS_ACTIVE_PAGE      = 'SET_HAS_ACTIVE_PAGE';
export const SET_IS_VALID_ADMIN_TOKEN = 'SET_IS_VALID_ADMIN_TOKEN';
export const SET_CONNECT              = 'SET_CONNECT';
